export default __webpack_public_path__ + "static/media/UNIVERSIDADE EM MOVIMENTO 15.02.2023.7bffb408.mp3";